<html>
<head>

</head>

<body class="mainframe mat-dialog-container">
  <main>
    <div class="topSquare">
      <img class ="imgOverlay" src="https://rhassets.s3.amazonaws.com/performance_point_logo.png" />
      <p class="contactUsText">Contact Us</p>
    </div>


    <div class="inputs" style="position: relative;left: -15px;">
      <div class="nameBox"><p class="nameText">Name</p><input type="text" id = 'name' style="position: relative;top: -43px;left: 65px;"/></div>
      <div class="emailBox"><p class="emailText">Email</p><input id = 'from' type="text" style="position: relative;top: -43px;left: 65px;"/></div>
      <div class="textBox"><textarea id='content' style="width: 100%;height: 100%;resize: none;" placeholder="Questions, comments, report issues, etc..." class=""></textarea></div>
    </div>

    <div class="submitButton">
      <p class="submitText" (click)="sendEmail()">Send</p>
    </div>




  </main>

</body>
  </html>
